import * as React from 'react';
import * as ProgressPrimitive from '@radix-ui/react-progress';
import { cn } from 'src/lib/utils';

const Progress = React.forwardRef<
  React.ComponentRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root>
>(({ className, value, ...props }, ref) => {
  return (
    <ProgressPrimitive.Root
      ref={ref}
      className={cn('relative h-4 w-full overflow-hidden rounded-full bg-purple_light', className)}
      {...props}
    >
      <ProgressPrimitive.Indicator
        className="h-full w-full flex-1 bg-purple_750 transition-all"
        style={{
          transform: `translateX(-${100 - (value || 0)}%)`,
        }}
      />
      <span className={'select-none text-white font-medium'}>
        {Number.parseInt(String(value))}%
      </span>
    </ProgressPrimitive.Root>
  );
});
Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
